import CTAButton from '../../../../../ui/ctaButton';
import { Gapper } from '../../../../../ui/utils';
import { Title, Text, Image, Wrapper } from './styles';

const AlreadyClient = ({
  title,
  text,
  image = { src: '', alt: '' },
  buttonText,
  onClick = () => {},
}) => {
  const handleButtonClick = () => {
    onClick && onClick();
  };
  return (
    <Wrapper gap={50}>
      <Gapper gap={14}>
        <Title>{title}</Title>
        <Text dangerouslySetInnerHTML={{ __html: text }} />
      </Gapper>
      {image.src && <Image src={image.src} alt={image.alt} loading="lazy" />}
      {buttonText && <CTAButton text={buttonText} onClick={handleButtonClick} />}
    </Wrapper>
  );
};

export default AlreadyClient;
